<template>
  <div id="app">
    <keep-alive>
      <router-view class="mk_nav_content" v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view class="mk_nav_content" v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
import { getUSER, getJWT, removeUSER, getLoginUrl, setJWT, setUSER } from "./api/constant";
import { getRequest } from "./api/api";
import { getUrlParam } from "./api/util";


export default {
  updated() {
    window.scroll(0, 0);
  },

  created() {

    const code = getUrlParam('code');
    console.log('code', code);

    if (code) {
      getRequest({
        url: "/security/getUserToken?code=" + code
      }).then((res) => {
        if (res.errcode == 200) {
          console.log('update jwt', res.data.token);

          setJWT(res.data.token);
          setUSER(res.data.userPO);

          this.$store.commit("setUser", res.data);
          //window.location.href = '/property-page/';
          window.location.href = 'http://' + window.location.host + window.location.pathname
        }
      });
    }

    //获取token保存的时间并加上多久后失效的时间(目前暂定60分钟后失效)
    let jwtTime = null
    //if (getJWTTime()) jwtTime = getJWTTime() + 1000 * 60 * 60

    // 每一分钟循环判断一次是否超过token保存时间
    //let jwtInterval = setInterval(() => {
    //  let newTime = new Date().getTime()
      // console.log("计算中", jwtTime, newTime);

      // 超过保存时间后退出登录并停止循环
    //  if (!jwtTime || newTime >= jwtTime) {
    //    console.log("token timeout", newTime, jwtTime);
    //    jwtTime = null
    //    removeUSER()
    //  }
    //}, 60000)
  },
};
</script>
<style lang="scss">
@import "style/layout.scss";

textarea {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

// 特效阴影
.photocopy {
  transition: box-shadow 0.3s, border-color 0.3s;
  visibility: visible;
  box-shadow: 0px 0px 20px #ccc;
}

a {
  text-decoration: none;
}

// 最小高度
.minH {
  min-height: 600px;
}

.crumbs {
  font-size: 12px;
  color: #86909c;
  margin-bottom: 35px;
}

// 后台传来的富文本样式设置
figure.image {
  margin-left: auto;
  margin-right: auto;
}

.nes {

  p,
  span {
    margin: 8px 0;
  }
}

figure {

  table,
  td {
    border: grey solid 1px;
    border-collapse: collapse;
  }

  td {
    padding: 0 10px;
  }

  table {
    margin-left: auto;
    margin-right: auto;
  }
}

.image-style-block-align-left {
  margin-left: 0;
}

.image-style-block-align-right {
  margin-right: 0;
}
</style>
